module.exports = __webpack_public_path__ + "static/media/Medcare Medical Centre, Al Barsha.f8a1fedf.jpg";